import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'excel'

export type TBrandedExcelTab = { name: string; subtitle?: string; data: Array<Array<string | number>> }

export type TBrandedExcelRequest = {
  title?: string
  subtitle?: string
  fileName?: string
  locale?: string
  /** The firm the workbook is about: it carries that firm's logo (management: any firm, otherwise your own) */
  firmId?: string
  tabs: TBrandedExcelTab[]
}

export type TBrandedExcelResponse = {
  base64: string
  fileName: string
}

const getTabs = <T>(axios: IFactoryFunctionRequest<any, Array<T>>) => (excelData: Array<T>) => {
  return axios({
    method: EMethod.post,
    data: excelData,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/tabs`,
  })
}

const getBrandedWorkbook =
  (axios: IFactoryFunctionRequest<TBrandedExcelResponse, TBrandedExcelRequest>) =>
  (payload: TBrandedExcelRequest) => {
    return axios({
      method: EMethod.post,
      data: payload,
      url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/branded`,
    })
  }

export default (axios: AxiosInstance) => ({
  getTabs: getTabs(useAxios(axios)),
  getBrandedWorkbook: getBrandedWorkbook(useAxios(axios)),
})
